import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";

const ContactUs = () => {
  return (
    <section className="relative w-full pt-36 md:pt-24 bg-[#FFFBF4] overflow-hidden">
      {/* MAP HERO */}
      <div
        className="relative h-[240px] sm:h-[320px] md:h-[420px] lg:h-[520px] w-full bg-center bg-cover bg-fixed"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.32), rgba(0,0,0,0.32)), url('https://images.unsplash.com/photo-1524995997946-a1c2e315a42f')",
        }}
      >
        {/* Center Title */}
        <div className="absolute inset-0 flex items-center justify-center px-4 text-center">
          <div className="text-white">
            <p className="tracking-[0.35em] text-[11px] sm:text-[12px] md:text-[13px] uppercase opacity-90">
              CONTACT
            </p>
            <h1 className="mt-2 text-[34px] font-serif sm:text-[46px] md:text-[60px] lg:text-[72px] leading-none font-medium">
              Contact Us
            </h1>
          </div>
        </div>
      </div>

      {/* CONTACT STRIP */}
      <div className="bg-[#FFFBF4]">
        <div className="mx-auto max-w-[640px] px-5 pb-14 sm:pb-16">
          {/* Make all content center aligned on all breakpoints */}
          <div className="flex flex-col items-center text-center">

            {/* Contact Email & Address */}
            <div className="mt-12 pt-8 w-full flex flex-col items-center">
              <h3 className="text-[18px] font-medium text-black/80 mb-6">Get in Touch</h3>
              <div className="flex flex-col gap-3 items-center text-[15px] text-black/65 mb-7">
                {/* Email */}
                <a
                  href="mailto:singhsweta112@gmail.com"
                  className="flex items-center gap-2 hover:text-[#FACC15] transition"
                  style={{ textDecoration: "none" }}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="inline"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M2.25 6.75A2.25 2.25 0 0 1 4.5 4.5h15a2.25 2.25 0 0 1 2.25 2.25v10.5A2.25 2.25 0 0 1 19.5 19.5h-15A2.25 2.25 0 0 1 2.25 17.25V6.75z" stroke="currentColor" strokeWidth="1.5" />
                    <path d="m3 7.5 8.547 6.43a.75.75 0 0 0 .906 0L21 7.5" stroke="currentColor" strokeWidth="1.5" />
                  </svg>
                  singhsweta112@gmail.com
                </a>
                {/* Address */}
                <span className="flex items-center gap-2">
                  <FaMapMarkerAlt className="inline-block" size={16} />
                  Delhi, India
                </span>
              </div>
            </div>

            {/* Social Handles */}
            <div className="mt-4 w-full flex flex-col items-center">
              <h3 className="text-[18px] font-medium text-black/80">
                Social Handles
              </h3>
              <div className="mt-4 flex flex-wrap gap-3 justify-center">
                <SocialPill name="Instagram" href="https://www.instagram.com/authorsweta2025" />
                {/* 
                <SocialPill name="Facebook" href="#" />
                <SocialPill name="Twitter" href="#" />
                <SocialPill name="LinkedIn" href="#" />
                */}
              </div>
            </div>

            {/* 
            <div className="rounded-2xl border border-black/10 bg-white p-6 shadow-sm sm:p-10 mt-14 w-full max-w-xl flex flex-col items-center">
              <h3 className="text-[22px] font-medium text-black/90 sm:text-[26px]">
                Contact Form
              </h3>
              <p className="mt-3 text-[14px] leading-7 text-black/50">
                Fill in the form and we’ll get back to you within 24 hours.
              </p>
              <form className="mt-8 space-y-5 w-full" autoComplete="off">
                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                  <Input label="First Name" placeholder="John" autoComplete="given-name" />
                  <Input label="Last Name" placeholder="Doe" autoComplete="family-name" />
                </div>
                <Input label="Email" placeholder="john@example.com" type="email" autoComplete="email" />
                <Input label="Phone" placeholder="+1 234 567 8901" type="tel" autoComplete="tel" />
                <div>
                  <label className="mb-2 block text-[13px] font-medium text-black/70" htmlFor="message">
                    Message
                  </label>
                  <textarea
                    id="message"
                    rows={5}
                    placeholder="Write your message..."
                    className="w-full rounded-xl border border-black/10 px-4 py-3 text-[14px] text-black/80 outline-none transition focus:border-black/30"
                  />
                </div>
                <button
                  type="submit"
                  className="w-full rounded-xl bg-black px-6 py-3 text-[14px] font-medium text-white transition hover:bg-black/90"
                >
                  Send Message
                </button>
                <p className="text-center text-[12px] text-black/40">
                  By submitting, you agree to be contacted back.
                </p>
              </form>
            </div>
            */}
          </div>
        </div>
      </div>
      {/* 
      <iframe
          title="Google Map"
          className="w-full h-[200px] md:h-[400px] object-cover"
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.9975956161774!2d-73.99950092390456!3d40.72312297139156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2598e55cbf9df%3A0x4ab83dc2f99c8b5c!2sSoHo%2C%20New%20York%2C%20NY%2010012%2C%20USA!5e0!3m2!1sen!2sin!4v1736660000000"
          style={{ border: 0 }}
        />
      */}
    </section>
  );
};

/* ------------------------ Sub Components ------------------------ */

const SocialPill = ({ name, href }) => {
  return (
    <a
      href={href || "#"}
      target="_blank"
      rel="noopener noreferrer"
      className="rounded-full border border-black/10 px-4 py-2 text-[13px] text-black/60 transition hover:border-black/30 hover:text-black/80"
      style={{ display: "inline-block" }}
      aria-label={name}
    >
      {name}
    </a>
  );
};

export default ContactUs;
